import api from '@/lib/api'

/** Carrega uma listagem auxiliar e garante o contrato `{ data: [] }` da API. */
export async function fetchReferenceList(endpoint, params) {
  const { data } = await api.get(endpoint, { params })

  if (!Array.isArray(data?.data)) {
    throw new TypeError(`A API retornou uma lista inválida para ${endpoint}.`)
  }

  return data.data
}
